// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8fde84e9","239":"4f7488c2","453":"f3365660","455":"5a7fe586","570":"c4342f52"}[chunkId] + ".chunk.js";
};